<template>
  <div class="Logout">
    <div class="Upper"> {{ $t('logout.farewell') }} </div>
    <div class="Middle">
      {{ $t('logout.loggingOut') }}<br/><br/>
      <img src="loading-balls-line.gif"/>
    </div>
    <div class="Lower"> <br/> <button type="button" class="btn-secondary" v-on:click="logoutButton()">{{ $t('logout.instantLogin') }}</button> </div>
  </div>
</template>

<script>
export default {
  name: 'Logout',
  props: {},
  data: function(){
    return {
    };
  },
  created: function(){},
  mounted: function(){
    let view = this;
      if(view.$parent.defaultLogin == '4digit'){
        view.$parent.page = 'login-4-digit';
      }else if(view.$parent.defaultLogin == 'qr'){
        view.$parent.page = 'login-qr';
      }else{
        view.$parent.page = 'login-4-digit';
      }
  },
  destroyed() {
  },
  methods: {
    logoutButton: function(){
      let view = this;
      if(view.$parent.defaultLogin == '4digit'){
        view.$parent.page = 'login-4-digit';
      }else if(view.$parent.defaultLogin == 'qr'){
        view.$parent.page = 'login-qr';
      }else{
        view.$parent.page = 'login-4-digit';
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .Logout{
    margin-top: 20px;
    background-color: #fff;
    width: 100%;
    height: 325px;
    text-align: center;
    overflow: hidden;
  }
  .Logout .Upper{
    text-align: center;
    width: 100%;
    background-color: #fff;
    margin-top:90px;
    margin-bottom:15px;

    font-family: DistrictProMedium;
    color: #808080;
    font-size: 20px;
  }
  .Logout .Middle{
    text-align: center;
    width: 100%;
    background-color: #fff;
    margin-top:15px;
    margin-bottom:25px;

    font-family: DistrictProMedium;
    color: #b2b2b2;
    font-size: 18px;
  }
  .Logout .Lower{
    text-align: center;
    width: 100%;
    background-color: #fff;
    margin-top:25px;
    margin-bottom:15px;

    font-family: DistrictProMedium;
    color: #b2b2b2;
    font-size: 18px;
  }
  .btn-secondary {
    display: inline-block;
    padding: 6px 12px;
    color: #fff;
    background-color: #6c757d;
    border: 1px solid #6c757d;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    user-select: none;
  }
</style>
